export default "__VITE_ASSET__e7Jk7RN___"